import api from '@/api/index';
import { create as createFaqTree } from '@/helpers/faqTree/create';

export default {
    namespaced: true,
    state: {
        isFaqDataLoaded: false,
        isFaqTreeExist: false,
        isFaqLoadedWithError: false,
        articleList: [],
        categoryList: [],
        faqTree: {},
    },
    getters: {
        getRootTreeItemPath: state => {
            return state.faqTree.fullPath;
        },
    },
    mutations: {
        setFaqTree(state, faqTree) {
            return state.faqTree = faqTree;
        },
        setArticleList(state, articleList) {
            return state.articleList = articleList;
        },
        setCategoriesList(state, categoryList) {
            return state.categoryList = categoryList;
        },
        setFaqTreeExist(state) {
            return state.isFaqTreeExist = true;
        },
        setFaqDataLoaded(state) {
            return state.isFaqDataLoaded = true;
        },
        setFaqLoadedWithError(state) {
            return state.isFaqLoadedWithError = true;
        },
    },
    actions: {
        async fetchFaqData({ commit }) {
            try {
                const [articles, categories] = await Promise.all([
                    api.getArticles(this.state.queryParams),
                    api.getCategories(this.state.queryParams)
                ]);
                commit('setArticleList', articles)
                commit('setCategoriesList', categories)

                if (articles.length === 0 && categories.length === 0) return;

                commit('setFaqTree', createFaqTree(articles, categories));
                commit('setFaqTreeExist');
            } catch (error) {
                commit('setFaqLoadedWithError');
                console.error(error)
            } finally {
                commit('setFaqDataLoaded');
            }
        }
    },
};